<template>
  <v-container
    fluid
    class="main-container"
    fill-height>
    <v-container
      class=""
      style="margin-top: 10%">
      <v-row class="justify-center">
        <v-dialog
          persistent
          v-model="privacyNotice"
          max-width="300">
          <v-card tile>
            <v-card-title class="text-h5 mb-3">🚨 개인정보 관련 안내</v-card-title>
            <v-card-text class="text-body-1">
              '생애설계 설문'은 개인 정보 보호를 위해
              <br />
              성명, 주민등록번호, 전화번호 등
              <br />
              개인식별 정보를 요구하지 않으며,
              <br />
              <br />
              향후 설문결과 제공과 상담 진행을 위해서
              <br />
              <span class="font-weight-bold red--text">닉네임과 이메일</span>
              을 활용하고 있습니다
              <br />
              <br />

              관련 통계자료를 작성할 경우에는
              <br />
              개인 식별이 불가능하도록
              <br />
              현황 자료 형태로 제공함을 안내드립니다.
              <br />
              <v-divider class="my-3" />
              확인 버튼을 누르면 <span class="font-weight-bold">삼성글로벌리서치</span>에서 <br />주관하는 설문으로 이동합니다.
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-btn
                plain
                text
                @click="privacyNotice = false"
                >건너뛰기</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                to="/survey"
                depressed
                >확인</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-col
          class="text-xs-center"
          cols="4">
          <div class="display-1 mb-3 q-message font-weight-bold">
            <!-- <v-icon color="primary" class="mr-2" large="large">mdi-fountain-pen-tip</v-icon> -->
            사용자 정보
          </div>
          <v-card
            light="light"
            width="500"
            flat
            outlined
            class="pa-3"
            tile>
            <v-card-text>
              <v-form
                ref="form"
                v-model="valid"
                :lazy-validation="lazy">
                <h3 class="font-weight-regular">강의코드를 입력해주세요</h3>
                <v-text-field
                  v-model="password"
                  :rules="[rules.required]"
                  counter="12"
                  required
                  prepend-icon="mdi-human-male-board"
                  label="강의코드"
                  placeholder="진행자가 알려주는 코드를 입력하세요"
                  class="ml-6 ml-3"></v-text-field>
                <h3 class="font-weight-regular">나만의 닉네임을 만들어주세요</h3>
                <v-text-field
                  v-model="user.name"
                  :rules="[rules.required]"
                  counter="12"
                  required
                  prepend-icon="mdi-account"
                  label="닉네임"
                  class="ml-6 ml-3"></v-text-field>
                <h3 class="font-weight-regular">생애연표를 받으실 이메일 주소를 남겨주세요</h3>
                <v-text-field
                  v-model="user.account"
                  l
                  :rules="[rules.required, rules.emailRules]"
                  prepend-icon="mdi-email"
                  label="이메일"
                  type="email"
                  class="ml-6"
                  counter="40"
                  required></v-text-field>
                <!-- <v-text-field v-model="user.password" light="light" prepend-icon="mdi-lock" label="Password" type="password"></v-text-field>
              <v-checkbox v-if="options.isLoggingIn" v-model="options.shouldStayLoggedIn" light="light" label="Stay logged in?" hide-details="hide-details"></v-checkbox> -->

                <!-- <v-btn v-else block="block" type="submit" @click.prevent="options.isLoggingIn = true">Sign up</v-btn> -->
              </v-form>
            </v-card-text>
            <v-card-actions class="pa-6 mt-3">
              <v-btn
                tile
                color="secondary"
                class="title"
                absolute
                left
                outlined
                @click.prevent="submit"
                :disabled="isVerified()"
                >교육 이어가기</v-btn
              >
              <v-btn
                tile
                color="secondary"
                class="title"
                depressed
                absolute
                right
                @click.prevent="begin"
                :disabled="isVerified()"
                >교육 시작하기</v-btn
              >
            </v-card-actions>
          </v-card>
          <!-- <div v-if="options.isLoggingIn">
          Don't have an account?
          <v-btn light="light" @click="options.isLoggingIn = false">Sign up</v-btn>
        </div> -->
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'
export default {
  async created() {
    this.fetchHousePension()
      .then((data) => {
        console.log('FETCH - HOUSEPENSION')
        console.log(data)
      })
      .catch((error) => {
        // you got an error!
      })
    if (this.$route.query.name) {
      this.hash = 'admin'
      console.log(this.$route.query.name, this.hash)
    } else this.getClassHash({ classId: this.classId }).then((h) => (this.hash = h))
  },
  mounted() {
    if (this.$route.query['survey'] === 'done') {
      this.privacyNotice = false
    }
    const userName = this.$route.query.name
    if (this.userNick.length > 0) {
      this.user.name = this.userNick
      this.user.account = this.userEmail.split(/@/)[0]
      this.user.domain = this.userEmail.split(/@/)[1]
    }
    // console.log(userName)
    if (userName) {
      console.log('00000')
      this.user.name = userName
    }
  },
  data() {
    return {
      hash: undefined,
      privacyNotice: true,
      valid: true,
      lazy: false,
      password: '',
      user: {
        name: '',
        account: '',
        domain: '',
      },
      rules: {
        required: (value) => !!value || '꼭 써주셔야 합니다',
        // nick: (v) => /^[a-zA-Z]+$/.test(v) || '영문으로 입력해주세요',
        emailRules: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || '올바른 이메일 형식이 아닙니다'
        },
      },
      options: {
        isLoggingIn: true,
        shouldStayLoggedIn: true,
      },
    }
  },
  methods: {
    isVerified() {
      if (this.hash == 'admin') return false
      const hashCode = (s) =>
        s.split('').reduce((a, b) => {
          a = (a << 5) - a + b.charCodeAt(0)
          return a & a
        }, 0)
      const hash = hashCode(this.password)
      // console.log(hash, this.hash)
      return !(hash === this.hash)
    },
    ...mapActions(['fetchHousePension', 'login', 'signUp', 'getClassHash']),
    ...mapMutations(['setUserEmail', 'setUserNick', 'setMaster', 'setFinance', 'setCareer', 'setClassId', 'setClass', 'setCompareAggregation']),
    async begin() {
      if (!this.classId && this.classId === '') {
        this.$dialog.error({
          text: '잘못된 접근입니다 (클래스를 선택하지 않으셨습니다)',
          title: '오류',
        })
        this.$router.push('/')
        return
      }
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      if (!pattern.test(this.user.account) || (this.user.name || '').length === 0) {
        this.$dialog.error({
          text: '입력 형식에 맞게 이름과 이메일을 적어주세요',
          title: '오류',
        })
        return
      }

      const [err, res] = await this.signUp({
        classId: this.classId,
        username: this.user.name,
        email: this.user.account,
      })
      if (err) {
        this.$dialog.error({
          text: '사용된 이메일이거나 이번 설문이 시작되지 않았습니다!',
          title: '오류',
        })
      } else this.$router.push('/' + this.classId + '/master')
    },
    async submit() {
      console.log('SUBMIT')
      const classId = this.$route.params.classId

      const [err, res] = await this.login({
        classId: classId,
        username: this.user.name,
        email: this.user.account,
      })
      if (err) {
        this.$dialog.error({
          text: '입력한 이름이나 이메일, 클래스가 없습니다',
          title: '로그인 오류',
        })
      }
      // this.setUserNick(this.user.name)
      // this.setUserEmail(this.user.account + '@' + this.user.domain)
      else {
        console.log('LOGIN SUCCESS')
        const klass = await this.axios.get('/api/cClass/' + this.classId).then((res) => {
          this.setCompareAggregation(res.data.compareAggregation)
        })

        this.$router.push('/' + this.classId + '/master')
      }
    },
  },
  computed: {
    ...mapState(['userNick', 'userEmail', 'classId']),
  },
}
</script>

<style
  lang="scss"
  scoped>
.subheading {
  font-size: 16px;
}
</style>
